<template>
  <div class="grid grid-flow-row gap-2">
     <div v-for="(modifier, index) in selectedNode.modifiers" :key="index">
      <div v-if="modifier.type == 'LISSAJOUS'" class="grid grid-flow-col grid-cols-4 gap-x-2">
        <img :src="lissajous.on" />
        <img @click="() => { 
            selectedNode.count = 4000
            selectedNode.setModifier({type: 'Rose'})
          }" :src="rose.off" />
      </div>
      <div v-if="modifier.type == 'ROSE'" class="grid grid-flow-col grid-cols-4 gap-x-2">
        <img @click="() => { 
            selectedNode.count = 5000
            selectedNode.setModifier({type: 'Lissajous'})
          }" :src="lissajous.off" />
        <img :src="rose.on" />
      </div>
    </div>
    <div class="w-full my-2 h-px bg-gray-100"></div>
    <div v-for="(stroke, index) in selectedNode.children[0].strokes" :key="index">
      <div v-if="!stroke.deleted">
        <InputColor
          id="solid"
          class="mb-2"
          type="color"
          label="Solid"
          :model="stroke"
          :mainSelectedNode="mainSelectedNode"
          v-model="stroke.val"
          @changeValue="(event) => changeFillValue(event, stroke, 'val')"
        />
        <InputNumber
          id="opacity"
          class="mb-2"
          label="Opacity"
          :mainSelectedNode="mainSelectedNode"
          v-model="stroke.opacity"
          @changeValue="(event) => changeFillValue(event, stroke, 'opacity')"
          :min="1"
          :max="100"
          :step="1"
        />
        <!-- <button class="pb-4 text-red-500" @click="stroke.remove()">Remove</button> -->
      </div>
    </div>
    <InputNumber
      id="count"
      label="Length"
      propertyName="count"
      :mainSelectedNode="mainSelectedNode"
      v-model="selectedNode.count"
      @changeValue="changeValue"
      :min="1"
      :max="5000"
      :step="1"
    />
    <div v-for="(modifier, index) in selectedNode.modifiers" :key="index" class="grid grid-flow-row gap-2">
      <InputNumber
        id="constX"
        label="A"
        :model="modifier"
        :mainSelectedNode="mainSelectedNode"
        v-model="modifier.constX"
        @changeValue="(event) => changeModifierValue(event, modifier, 'constX')"
        :min="1"
        :max="20"
        :step="1"
      />
      <InputNumber
        id="constY"
        label="B"
        :model="modifier"
        :mainSelectedNode="mainSelectedNode"
        v-model="modifier.constY"
        @changeValue="(event) => changeModifierValue(event, modifier, 'constY')"
        :min="1"
        :max="20"
        :step="1"
      />
      <InputNumber
        v-if="modifier.type == 'LISSAJOUS'"
        id="delta"
        label="Angle"
        :model="modifier"
        :mainSelectedNode="mainSelectedNode"
        v-model="modifier.delta"
        @changeValue="(event) => changeModifierValue(event, modifier, 'delta')"
        :min="0"
        :max="2"
        :step="0.01"
      />
      <InputNumber
        id="amplitudeX"
        label="Width"
        :model="modifier"
        :mainSelectedNode="mainSelectedNode"
        v-model="modifier.amplitudeX"
        @changeValue="(event) => changeModifierValue(event, modifier, 'amplitudeX')"
        :min="0.1"
        :max="10"
        :step="0.1"
      />
      <InputNumber
        id="amplitudeY"
        label="Height"
        :model="modifier"
        :mainSelectedNode="mainSelectedNode"
        v-model="modifier.amplitudeY"
        @changeValue="(event) => changeModifierValue(event, modifier, 'amplitudeY')"
        :min="0.1"
        :max="10"
        :step="0.1"
      />
      <InputNumber
        v-if="modifier.type == 'LISSAJOUS'"
        id="theta"
        label="Step"
        :model="modifier"
        :mainSelectedNode="mainSelectedNode"
        v-model="modifier.theta"
        @changeValue="(event) => changeModifierValue(event, modifier, 'theta')"
        :min="1"
        :max="100"
        :step="1"
      />
      <InputNumber
        id="increase_theta"
        label="Lines"
        :model="modifier"
        :mainSelectedNode="mainSelectedNode"
        v-model="modifier.increase_theta"
        @changeValue="(event) => changeModifierValue(event, modifier, 'increase_theta')"
        :min="0.025"
        :max="2.073"
        :step="0.001"
      />
      <div class="w-full my-2 h-px bg-gray-100"></div>
      <Button @click="sendToFigma(scale)" :style="'primary'" :label="`Export PNG (${ selectedNode.parent.width * scale } x ${ selectedNode.parent.height * scale })`" />
      <InputNumber
        id="scale"
        label="Scale"
        :model="scale"
        v-model="scale"
        @changeValue="(event) => changeScale(event)"
        :min="1"
        :max="4"
        :step="1"
      />
  </div>
</div>

</template>
<script>

import Button from '../../core/src/components/Button'
import InputText from '../../core/src/components/InputText'
import InputNumber from '../../core/src/components/InputNumber'
import InputColor from '../../core/src/components/InputColor'
import InputCheckbox from '../../core/src/components/InputCheckbox'
import { Pixel } from '../../core/src/lib';

export default {
  components: {
    Button,
    InputText,
    InputNumber,
    InputColor,
    InputCheckbox
  },
  props: 
  [
    "children",
    "mainSelectedNode",
    "selectedNode",
    "index",
    "name",
    "mainNode"
  ],
  data() {
    return {
      scale: 1,
      lissajous:{
        off: require('../../core/src/assets/lissajous_off.svg'),
        on: require('../../core/src/assets/lissajous_on.svg')
      },
      rose:{
        off: require('../../core/src/assets/rose_off.svg'),
        on: require('../../core/src/assets/rose_on.svg')
      },
    }
  },
  methods: {
    changeModifierValue(event, modifier, propertyName) {
      const mv = modifier[propertyName]
      modifier.set(propertyName, event.target.value)
      if (mv !== event.target.value) {
        event.target.value = mv
      }
    },
    changeValue(event, propertyName) {
      const mv = this.mainSelectedNode.get(propertyName)
      this.mainSelectedNode.set(propertyName, event.target.value)
      if (mv !== event.target.value) {
        event.target.value = mv
      }
    },
    changeFillValue(event, fill, propertyName) {
      const mv = fill[propertyName]
      fill.set(propertyName, event.target.value)
      if (mv !== event.target.value) {
        event.target.value = mv
      }
    },
    async sendToFigma(scale = 1){
      let msg = {
        w: Pixel.width * scale,
        h: Pixel.height * scale,
        uint8Array: await Pixel.convertCanvas(scale)
      }
      parent.postMessage(msg, '*');
    },
    changeScale(event) {
      this.scale = event.target.value
    },
  },
  computed: {
   
  },
  mounted(){
  }
}
</script>
<style scoped lang="postcss">
  .btn {
    @apply bg-indigo-600 p-2 mr-2 rounded text-white hover:bg-indigo-700;
  }
</style>
